import React from 'react'
import PropTypes from 'prop-types'
import SortDescIconSVG from './assets/sort-desc-icon.svg'
import SortDefaultIconSVG from './assets/sort-default-icon.svg'
import SortAscIconSVG from './assets/sort-asc-icon.svg'

const SortingIcon = ({ className, state }) => {
  switch (state) {
    case 'asc':
      return <SortAscIconSVG className={className} />
    case 'desc':
      return <SortDescIconSVG className={className} />
    default:
      return <SortDefaultIconSVG className={className} />
  }
}

SortingIcon.propTypes = {
  className: PropTypes.string,
  state: PropTypes.oneOf(['asc', 'desc', 'none']),
}

export default SortingIcon
